const firebaseConfig = {
    apiKey: "AIzaSyCxQuIjZb-nnK4RWieqdLuMA56uDStPRnM",
    authDomain: "my-crypto-77d4b.firebaseapp.com",
    projectId: "my-crypto-77d4b",
    storageBucket: "my-crypto-77d4b.appspot.com",
    messagingSenderId: "502257480614",
    appId: "1:502257480614:web:5fac561267275276765567"
  };

  export default firebaseConfig;